"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const IconButton = React.forwardRef((props, ref) => {
    const { children, color = 'default' } = props, rest = tslib_1.__rest(props, ["children", "color"]);
    return ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({}, rest, { color: color, disableTouchRipple: true, ref: ref }, { children: children })));
});
exports.default = React.memo(IconButton);
